export const EC_RAIL_BASENAME = '/ec';

/**
 * One build serves both Socotra rails: `/…` renders against the CC endpoints (unchanged)
 * and `/ec/…` renders the same screens against the EC Ninja endpoints. The rail is fixed
 * for the lifetime of the page, so it is detected once from the URL at module load.
 */
export const isEcRailPathname = (pathname: string): boolean =>
  pathname === EC_RAIL_BASENAME || pathname.startsWith(`${EC_RAIL_BASENAME}/`);

export const IS_EC_RAIL: boolean = isEcRailPathname(window.location.pathname);

export const RAIL_BASENAME: string = IS_EC_RAIL ? EC_RAIL_BASENAME : '/';

// The lookahead keeps hypothetical sibling paths (e.g. `consumer-submissions-report`) unrewritten.
const CONSUMER_SUBMISSION_API_URL_PATTERN = /^(\/?)consumer-submission(?=[/?]|$)/;

/**
 * Routes `consumer-submission…` API calls to `ec/consumer-submission…` on the EC rail.
 * Rail-agnostic endpoints (smarty, prometrix, vintelligence, …) pass through untouched.
 */
export const toRailApiUrl = (url: string, isEcRail: boolean = IS_EC_RAIL): string =>
  isEcRail ? url.replace(CONSUMER_SUBMISSION_API_URL_PATTERN, '$1ec/consumer-submission') : url;

/**
 * Prefixes the rail basename onto absolute in-app paths that bypass the router
 * (`window.location.href` assignments, externally-visible return URLs).
 */
export const withRailBasename = (absolutePath: string, isEcRail: boolean = IS_EC_RAIL): string => {
  if (!isEcRail) {
    return absolutePath;
  }

  return absolutePath === '/' ? EC_RAIL_BASENAME : `${EC_RAIL_BASENAME}${absolutePath}`;
};
